module.exports = __webpack_public_path__ + "img/bus-outlined-black.07a06b20.svg";